import { injectScript, loadOnlyApp } from './browserApp';

// Crisp's chat box: the website id set on the page, then Crisp's loader, as its own snippet does.
// https://docs.crisp.chat/guides/chatbox-sdks/web-sdk/

type CrispWindow = Window & { $crisp?: unknown[]; CRISP_WEBSITE_ID?: string };

// Loads Crisp's chat box for the website, once.
const install = (settings: Record<string, string | boolean>): void => {
  const websiteId = String(settings.websiteId || '');
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(websiteId)) return;
  const target = window as CrispWindow;
  target.$crisp ??= [];
  target.CRISP_WEBSITE_ID = websiteId;
  injectScript('xshop-crisp', 'https://client.crisp.chat/l.js');
};

export const crispApp = loadOnlyApp(install);
